module.exports = __webpack_public_path__ + "static/img/irole.cfc08ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/ch/irole.png
// module id = ouKw
// module chunks = 7